import React, { Component, Fragment } from 'react';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import Dropzone from 'react-dropzone';
import styles from './FileInput.styles';

import Icon from '../../common/icon/Icon';

export class FileInput extends Component {
  state = {
    errors: []
  };
  onDrop = (accepted, rejected) => {
    const { dropzoneOptions } = this.props;
    let extensions = dropzoneOptions.accept
      .replace(/[. ]/g, '')
      .replace(/,/g, '|');
    this.setState({
      errors: rejected.map(file => {
        if (!file.type.match(extensions)) {
          return I18n.t('error.fileFormat', {
            extensions: dropzoneOptions.accept
          });
        } else if (file.size > dropzoneOptions.maxSize) {
          return I18n.t('error.fileSize', {
            size: `${Math.round(dropzoneOptions.maxSize / 1024 / 1024)}MB`
          });
        }
        return I18n.t('error.fileUpload');
      })
    });
    this.props.onChange(accepted);
  };
  renderFile = (file, index) => (
    <span key={index} className={css(styles.filename)}>
      {file.name}
    </span>
  );
  renderError = (error, index) => (
    <span key={index} className={css(styles.error)}>
      {error}
    </span>
  );
  render() {
    const { name, styles: customStyles, dropzoneOptions } = this.props;
    return (
      <Dropzone
        name={name}
        {...dropzoneOptions}
        onDrop={this.onDrop}
        className={css(styles.dropzone, customStyles)}
        onClick={e => e.preventDefault()}
      >
        <Fragment>
          <Icon value="cloud-upload" styles={styles.icon} />
          {this.props.value &&
            !!this.props.value.length &&
            this.props.value.map(this.renderFile)}
          <span className={css(styles.label)}>
            {I18n.t('fileupload.drop', {
              extensions: dropzoneOptions.accept
            })}
          </span>
          <div className={css(styles.errors)}>
            {!!this.state.errors.length &&
              this.state.errors.map(this.renderError)}
            {this.props.error && this.renderError(this.props.error)}
          </div>
        </Fragment>
      </Dropzone>
    );
  }
}

export default FileInput;



// WEBPACK FOOTER //
// ./src/components/inputs/fileinput/FileInput.js